import React from "react";

import { IconProps } from "../services/Icon.types";

const ServiceIcon: React.FC<IconProps> = ({ colourFill }) => {

    return (        
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0107 13.6688L22.6607 18.0161L15.0107 22.3634V13.6688ZM36 3.85714V32.1429C36 34.2723 34.2723 36 32.1429 36H3.85714C1.72768 36 0 34.2723 0 32.1429V3.85714C0 1.72768 1.72768 0 3.85714 0H32.1429C34.2723 0 36 1.72768 36 3.85714ZM32.625 18.0241C32.625 18.0241 32.625 13.2348 32.0143 10.9366C31.6768 9.66696 30.6884 8.67054 29.4268 8.33304C27.1527 7.71429 18 7.71429 18 7.71429C18 7.71429 8.84732 7.71429 6.57321 8.33304C5.31161 8.67054 4.32321 9.66696 3.98571 10.9366C3.375 13.2268 3.375 18.0241 3.375 18.0241C3.375 18.0241 3.375 22.8134 3.98571 25.1116C4.32321 26.3813 5.31161 27.3375 6.57321 27.675C8.84732 28.2857 18 28.2857 18 28.2857C18 28.2857 27.1527 28.2857 29.4268 27.667C30.6884 27.3295 31.6768 26.3732 32.0143 25.1036C32.625 22.8134 32.625 18.0241 32.625 18.0241Z" fill={colourFill} />
        </svg>

    )
} 


export default ServiceIcon;

